import EuctoLogo from "../Images/blaccLogo.png";
import "../components/component.css";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Callheader from "../Images/Callheader.png";
import { useLocation, Link, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import DuoIcon from "@mui/icons-material/Duo";

function Header() {
  const location = useLocation(); // Hook to get the current path
  const navigate = useNavigate();

  const redirect = () => {
    window.open("https://stagebusiness.blaccdot.ca/login", "_self");
  };

  const goToService = () => {
    navigate("/#service");
  };

  return (
    <Navbar expand="lg" style={{ backgroundColor: "#fbfbfbee" }}>
      <Container>
        <Navbar.Brand href="/">
          <img src={EuctoLogo} alt="eucto" style={{ width: "100px" }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav style={{ alignItems: "center", margin: "0 8%" }}>
            <Nav.Link href="/">HOME</Nav.Link>
            <Nav.Link
              onClick={() =>
                document
                  .getElementById("service")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              style={{ cursor: "pointer" }}
            >
              SERVICE
            </Nav.Link>
            <Nav.Link
              onClick={() =>
                document
                  .getElementById("aboutus")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              ABOUT US
            </Nav.Link>
            {/* <Nav.Link href="/blogs">BLOGS</Nav.Link> */}
          </Nav>
          <Form
            className="d-flex"
            style={{ width: "100%", alignItems: "center" }}
          >
            {/* Conditional Button Rendering */}
            {/* {location.pathname === '/subscription' ? (
              <Link to="/appointment"><Button variant="outlined" startIcon={<DuoIcon />}>Book a Demo</Button></Link>
            ) : (
            <Link to='https://stagebusiness.blaccdot.ca/login'>  <Button 
              variant="contained"
              sx={{ 
                backgroundImage: "linear-gradient(-180deg, #2762B1, #2762B1)", 
                color: "#fff",
                "&:hover": {
                  backgroundImage: "linear-gradient(-180deg, #1E4A8A, #1E4A8A)" // Darker shade on hover
                }
              }}
            >
              Log in
            </Button></Link>
            )} */}
            <Link to="https://stagebusiness.blaccdot.ca/login">
              {" "}
              <Button
                variant="contained"
                className="login-button-responsive"
                sx={{
                  backgroundImage: "linear-gradient(-180deg, #2762B1, #2762B1)",
                  color: "#fff",
                  width: "140px",
                  "&:hover": {
                    backgroundImage:
                      "linear-gradient(-180deg, #1E4A8A, #1E4A8A)",
                  },
                }}
              >
                Log in
              </Button>
            </Link>

            <div
              style={{
                borderLeft: "1px solid green",
                height: "20px",
                marginLeft: "10px",
              }}
            ></div>
            <img
              src={Callheader}
              alt="imageCallheader"
              style={{ width: "15%", marginLeft: "10px" }}
            />
            <div className="d-grid">
              <span style={{ fontWeight: "100" }}>Have any Questions?</span>
              <span>support@blaccdot.ca</span>
            </div>
          </Form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
